import { SagaIterator } from "redux-saga";
import { call, put, takeLatest } from "redux-saga/effects";
import { IResponse } from "../../../../libs/requester/IResponse";
import { requester } from "../../../../libs/requester/requester-axios";
import { setUsers, setLoading, setGetUsersError } from "../../repository/slice";

function* getUsersWorker({ payload }: any): SagaIterator {
  const { name, ...body } = payload;
  try {
    yield put(setLoading(true));

    const isPhone = /^\+?\d+$/.test(payload.name);
    const query = {
      ...body,
      [isPhone ? "phone" : "name"]: payload.name,
    };

    const { data, message, isError }: IResponse<any> = yield call(
      requester.get,
      "/api/admin/user/get-list",
      query
    );
    if (isError) {
      yield put(setGetUsersError(message));
    } else {
      yield put(setGetUsersError(null));
      yield put(setUsers({ users: data.rows, count: data.count }));
    }
  } catch (error) {
    console.error("getUsersWorker: ", error);
  } finally {
    yield put(setLoading(false));
  }
}

export function* getUsersWatcher() {
  yield takeLatest("@saga/GET_USERS", getUsersWorker);
}
